import { defineAction } from "rd-action-creators";
import { SupportMessage } from "store/api";

export const openNotificationAction = defineAction<{ isOpen: boolean; message: string; isWarning?: boolean }>(
    "OPEN NOTIFICATION"
);
export const closeNotificationAction = defineAction<{}>("CLOSE NOTIFICATION");

export const sendSupportMessageAction = defineAction<SupportMessage>("SEND SUPPORT MESSAGE");

export const changeDashboardLinkAction = defineAction<{ link: string }>("CHANGE DASHBOARD LINK");
